import React from 'react';import { faCode, faLaptop, faPaintBrush } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './ServiceSample.css';
import { Link } from 'react-router-dom';

const services = [
    {
        serviceName: 'Web Design',
        icon: faLaptop,
        description: 'I am responsible for creating the design and layout of a website or web page. I can create a brand new website and update an already existing site.'
    },
    {
        serviceName: 'Web Developer',
        icon: faCode,
        description: 'I am responsible for designing, coding, and modifying websites, from layout to function, and according to clients specifications.'
    },
    {
        serviceName: 'Graphics Design',
        icon: faPaintBrush,
        description: 'I am expert in web designing. I can add functionality besides designing a webpage. I use HTML, CSS, Bootstrap, Vanilla Js, React JS for it.'
    },
];


const ServiceSample = () => {
    return (
        <div className="serviceSample container my-5">
            <h4 className="sub-title mb-5">What i Provide</h4>
            
            <div className="row">
                {
                    services.map(service => 
                        <div className="col-md-4">
                            <div className="service-item d-block mx-auto text-center">
                                <div className="icon">
                                    <FontAwesomeIcon icon={service.icon} />
                                </div>
                                <h5>{service.serviceName}</h5>
                                <p>{service.description}</p>
                            </div>
                        </div>    
                    )
                }
            </div>

            <Link to="/service" className="btn mt-5 d-block mx-auto custom-btn">More Services</Link>
        </div>
    );
};

export default ServiceSample;